import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as subawardTermsAndConditions from '../../subaward-terms-and-conditions'

export const RESOURCE = {
  payload: {
    description:
      'A contractual requirement governing the use of research funds and subaward compliance.',
    dimension: subawardTermsAndConditions.RESOURCE.payload,
    level: 0,
    name: 'Term/Condition',
    partialId: PartialId.Standard.create('tc'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
